/* eslint-disable @typescript-eslint/restrict-template-expressions */
import { IScriptActionArgument } from '@newo/api/gateway';

export const getArgumentDefaultValue = (data: IScriptActionArgument) => {
    switch (typeof data.default) {
        case 'string': {
            return `"${data.default}"`;
        }
        case 'number': {
            return data.default;
        }
        default: {
            return '';
        }
    }
};

export const getArgumentDescription = (
    argument: string,
    meta: IScriptActionArgument
) => {
    const fields = Object.entries(meta).map(([key, value]) => {
        if (key === 'anyOf') {
            const types = value as { type: string }[];
            return `\n\t\t${key}: ${types.map((v) => v.type).join(' | ')}`;
        }
        if (key === 'items') {
            const value_ = value as { type: string };
            return `\n\t\t${key}: ${value_.type}[]`;
        }
        // eslint-disable-next-line @typescript-eslint/no-base-to-string
        return `\n\t\t${key}: ${value}`;
    });

    return `**${argument}**:
      ${fields}
   `;
};
